$(document).ready(function () {
    $(".select-variant-addon").change(function(){
        $(this).parents(".addon-product-variants").siblings(".buy-btn-style--addToCart").find("input.product-variant-id").attr('value', $(this).attr('variant-id'));
        $(this).parents(".addon-product-variants").parents(".variant-selector-addToCart").siblings(".custom-buy-btn-parent").find("input.product-variant-id").attr('value', $(this).attr('variant-id'));
    });

    // $(".add-on-products .buy-btn-style .addToCart--btn-lg").click(function(){
    //     let var_id = parseInt($(this).parents(".buy-btn-style--addToCart").siblings(".product-form__input-css").find(".select-variant-addon:checked").attr("variant-id"));
    //     if(!var_id){
    //         var_id = $(this).attr('variant-id');
    //         console.log("empty");
    //         addItemToCart(var_id);
    //     }else{
    //         console.log(var_id);
    //         addItemToCart(var_id);
    //     }
    // });

    // $(".add-on-products .buy-btn-style .addToCart--btn-sm").click(function(){
    //     let var_id = parseInt($(this).parents(".custom-buy-btn-parent").siblings(".variant-selector-addToCart").find(".select-variant-addon:checked").attr("variant-id"));
    //     console.log(var_id);
    //     if(!var_id){
    //         var_id = $(this).attr('variant-id');
    //         console.log("empty");
    //         addItemToCart(var_id);
    //     }else{
    //         console.log(var_id);
    //         addItemToCart(var_id);
    //     }
    // });

    // // Common Cart Function
    // function addItemToCart(variant_id) {
        // $.ajax({
        //     type: "POST",
        //     url: "/cart/add.js",
        //     data: {
        //         quantity: 1,
        //         id: variant_id,
        //     },
        //     dataType: "json",
        //     success: function (data) {
        //         console.log(data);
        //         location.reload();
        //     },
        // });
    // }
    
    $(".footer .toggler-head .toggler-icon").click(function (e) { 
        e.preventDefault();
        $(this).parents(".toggler-head").siblings(".toggler-box").slideToggle();
        if($(this).text() == '+'){
            $(this).text("-");
        }else if($(this).text() == '-'){
            $(this).text("+");
        }
    });

    let selector = $(".header-wrapper .header__menu-item");
    $(selector).hover(function () { 
        $(this).siblings(".submenu-wrapper").slideDown();
    });
    $(selector).mouseleave(function () { 
        if($(".header-wrapper .submenu-wrapper:hover").length == 0)
            $(this).siblings(".submenu-wrapper").slideUp();
    });
    $(".header-wrapper .submenu-wrapper").mouseleave(function () { 
        if($(".header-wrapper .header__menu-item:hover").length == 0)
            $(this).slideUp();
    });

    
    $(".qstn-box .qstn-block .qstn").click(function(){
        $(this).parents(".qstn-block").siblings(".ans").slideToggle();
        $(this).parents(".qstn-block").siblings(".bg-shadow").toggle();
        $(this).parents(".qstn-box").toggleClass("shadow");
        $(this).children(".minus, .plus").toggle();
    });

    $("variant-radios .product-form__input input[type=radio]").change(function(){
        setTimeout(() => {
            $(".show-quantity-badge").load(" .show-quantity-badge");
        }, 500);
    });

    // toggle description on mobile
    $(".open-desc").click(function (e) { 
        e.preventDefault();
        $(this).siblings(".desc-product").slideToggle();
        if($(this).children(".plus-minus").text() == '+'){
            $(this).children(".plus-minus").text("-");
        }else if($(this).children(".plus-minus").text() == '-'){
            $(this).children(".plus-minus").text("+");
        }
    });
    $(".header-submenu-tablinks").hover(function(){
        $(".header-submenu-tablinks").removeClass("active");
        $(this).addClass("active");
        let targetTab = $(this).children("span").attr("data-bs-target");
        console.log(targetTab);
        $(".header-submenu-tabcontent").removeClass("show active");
        $(targetTab).addClass("show active");
    })
});